'use strict';

import React, { useEffect, useRef, useState } from 'react';
import AuthPanel from "./AuthPanel.jsx";
import SearchPanel from "./SearchPanel.jsx";
import ScrollToTop from './ScrollToTop.jsx';
import Tippy, { useSingleton } from "@tippy.js/react";
import tippy_defaults from './tippy-defaults.js';
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/pro-regular-svg-icons/faSearch";
import { faUserCircle } from "@fortawesome/pro-regular-svg-icons/faUserCircle";

function Menus({ menus, csrf, swiftype_engine, admin_content, article_key, current_url }) {
	const [loading, setLoading] = useState(true);
	const [user, setUser] = useState(window.logged_in_user || null);
	const [static_menus, setStaticMenus] = useState([]);
	
	const tippy_ref = useRef(null);
	const singleton = useSingleton({
		...tippy_defaults,
		updateDuration: 300,
		onCreate: instance => (tippy_ref.current = instance),
	});
	
	useEffect(() => {
		window.InterNACHI.session.onGuest(() => {
			setUser(null);
			setLoading(false);
		});
		window.InterNACHI.session.onLoaded(() => {
			setUser(window.logged_in_user);
			setLoading(false);
		});
	}, []);
	
	useEffect(() => {
		setStaticMenus(menus.map((i, element) => {
			const $trigger = $(element);
			return {
				key: i,
				title: $trigger.text(),
				html: $($trigger.attr('href')).html(),
				className: $trigger.attr('class'),
				containerClassName: $trigger.parent().attr('class'),
			};
		}).toArray());
	}, [menus]);
	
	const onSearchHide = () => {
		tippy_ref.current.hide();
	};
	
	const keepOpen = () => {
		tippy_ref.current.setProps({
			delay: [0, 9999999],
		});
	};
	
	const restoreDelay = () => {
		tippy_ref.current.setProps({
			delay: tippy_defaults.delay,
		});
	};
	
	const target = (title) => {
		if ('InterNACHI' in window && 'shared' in window.InterNACHI && 'running_unit_tests' in window.InterNACHI.shared) {
			return {
				dusk: `${ title } Menu`
					.toLowerCase()
					.trim()
					.replace(/[^\w\s-]/g, '')
					.replace(/[\s_-]+/g, '-')
					.replace(/^-+|-+$/g, ''),
			};
		}
		
		return {};
	};
	
	return (
		<React.Fragment>
			{ static_menus.map(({ key, title, html, className, containerClassName }) => {
				return (
					<div key={ key } className={ containerClassName }>
						<Tippy singleton={ singleton } content={ <div dangerouslySetInnerHTML={ { __html: html } } /> }>
							<span className={ `cursor-pointer ${ className }` } { ...target(title) }>
								{ title }
							</span>
						</Tippy>
					</div>
				);
			}) }
			<div className={ `ml-auto ${ loading ? 'hidden' : '' }` }>
				<Tippy singleton={ singleton } content={ <SearchPanel loading={ loading } onHide={ onSearchHide } engine={ swiftype_engine } /> }>
					<span className="py-2 mx-2 text-base text-white no-underline cursor-pointer font-condensed">
						<Icon icon={ faSearch } />
					</span>
				</Tippy>
			</div>
			<div className={ `${ loading ? 'hidden' : '' }` }>
				<Tippy
					singleton={ singleton }
					content={ <AuthPanel
						keepOpen={ keepOpen }
						restoreDelay={ restoreDelay }
						loading={ loading }
						user={ user }
						article_key={ article_key }
						admin_content={ admin_content }
						csrf={ csrf }
						current_url={ current_url }
					/> }
				>
					<span className={ "ml-4 py-2 text-white font-condensed text-base mx-2 no-underline cursor-pointer" }>
						<Icon icon={ faUserCircle } />
						{ user && <span className="inline-block ml-2">{ `${ user.given_name } ${ user.family_name }` }</span> }
						{ !user && <a href={ route('auth.login.show') } className="hidden ml-2 xl:inline-block text-white no-underline">Log In</a> }
					</span>
				</Tippy>
			</div>
			<ScrollToTop />
		</React.Fragment>
	);
}

export default Menus;
